import "./LinkedinConnectionProcess.scss"

import { SvgIcon } from "@skylead/component-library"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

// eslint-disable-next-line import/no-cycle
import {
  getLinkedinGlobalStatus,
  LINKEDIN_ACCOUNT_GLOBAL_STATUS,
  MODAL_HEADER_TITLE,
} from "../../../constants/account-statuses"
import * as actions from "../../../redux/actions"
import { store } from "../../../redux/store"
import { useGlobalTranslation, useInterval } from "../../../utils/hook"
// eslint-disable-next-line import/no-cycle
import CircularTimer from "../CircularTimer"
import LinkedinConnectionProgressBar from "../LinkedinConnectionProgressBar"
import OTPInput from "../OTPInput"

/** 15 minutes execution time */
const EXECUTION_TIME = 900000

const LinkedinConnectionProcess = ({ initialGlobalStatusState }) => {
  const shouldUpdateGlobalStatus = useRef(true)
  const { tt } = useGlobalTranslation()

  const dispatch = useDispatch()
  const [value, updateValue] = useState(initialGlobalStatusState)
  const [executionSeconds, setExecutionSeconds] = useState(null)
  const [executionMinutes, setExecutionMinutes] = useState(null)
  const [timeIsUp, setTimeIsUp] = useState(false)

  const [{ person, userMessage, accountStatuses }, { globalStatus, pinTimestamp }] = useSelector(
    state => [state.forms.formData, state.account],
  )

  const updateGlobalStatus = async () => {
    if (shouldUpdateGlobalStatus.current) {
      await dispatch(actions.getGlobalStatus())
      if (globalStatus && value !== LINKEDIN_ACCOUNT_GLOBAL_STATUS.TIMES_UP_CUSTOM_STATUS) {
        if (globalStatus === LINKEDIN_ACCOUNT_GLOBAL_STATUS.OFFLINE) {
          updateValue(LINKEDIN_ACCOUNT_GLOBAL_STATUS.AUTH_OK)
        } else {
          updateValue(globalStatus)
        }
      }

      if (
        [
          LINKEDIN_ACCOUNT_GLOBAL_STATUS.AUTH_OK,
          LINKEDIN_ACCOUNT_GLOBAL_STATUS.PIN_WRONG,
          LINKEDIN_ACCOUNT_GLOBAL_STATUS.WRONG_AUTH,
          LINKEDIN_ACCOUNT_GLOBAL_STATUS.TIMES_UP_CUSTOM_STATUS,
          LINKEDIN_ACCOUNT_GLOBAL_STATUS.OFFLINE,
          LINKEDIN_ACCOUNT_GLOBAL_STATUS.REGISTER_PHONE,
        ].includes(globalStatus)
      ) {
        shouldUpdateGlobalStatus.current = false
      }
    }
  }

  useInterval(updateGlobalStatus, 5000)
  const status = useMemo(() => {
    const statusObject = getLinkedinGlobalStatus(tt, value)
    const realStatus = (accountStatuses?.find(({ statusId }) => statusId === globalStatus) || {})
      .statusName

    const primaryBtn = statusObject.primaryBtn?.bind
      ? {
          ...statusObject.primaryBtn,
          onClick: statusObject.primaryBtn.onClick.bind(null, person, userMessage, accountStatuses),
        }
      : statusObject.primaryBtn

    dispatch(actions.updateFormField("headerClassRedux", statusObject.headerClass))
    dispatch(actions.updateFormField("titleRedux", MODAL_HEADER_TITLE(tt)[realStatus]))
    dispatch(actions.updateFormField("primaryBtnRedux", primaryBtn))
    dispatch(actions.updateFormField("secondaryBtnRedux", statusObject.secondaryBtn))
    dispatch(actions.updateFormField("tertiaryBtnRedux", statusObject.tertiaryBtn))
    dispatch(actions.updateFormField("footerVariantRedux", statusObject.footerVariant))
    dispatch(actions.updateFormField("noHideOnSubmitRedux", statusObject?.noHideOnSubmit))

    return statusObject
  }, [value])

  useEffect(() => {
    if (
      (globalStatus === LINKEDIN_ACCOUNT_GLOBAL_STATUS.PIN_REQUESTED ||
        globalStatus === LINKEDIN_ACCOUNT_GLOBAL_STATUS.PIN_WRONG) &&
      pinTimestamp
    ) {
      const requestedPinTime = pinTimestamp + EXECUTION_TIME
      const currentTime = Date.now()

      const date = new Date()
      date.setTime(requestedPinTime - currentTime)

      const seconds = date.getSeconds()
      const minutes = date.getMinutes()

      if (currentTime < requestedPinTime) {
        setExecutionSeconds(seconds)
        setExecutionMinutes(minutes)
      } else {
        setExecutionSeconds(0)
        setExecutionMinutes(0)
        setTimeIsUp(true)
        updateValue(LINKEDIN_ACCOUNT_GLOBAL_STATUS.TIMES_UP_CUSTOM_STATUS)
      }
    }

    if (
      globalStatus === LINKEDIN_ACCOUNT_GLOBAL_STATUS.AUTH_OK ||
      globalStatus === LINKEDIN_ACCOUNT_GLOBAL_STATUS.OFFLINE
    ) {
      const proxies = store.getState().app.proxyCountries
      if (proxies && proxies.length > 0) {
        store.dispatch(actions.updateFormField("selectedProxy", proxies[0].countryCode))
      }
    }
  }, [globalStatus])

  return (
    <>
      <div className="linkedin-connection-process">
        <div className="linkedin-connection-process__image-wrapper">
          {status.image && (
            <div className="position-relative">
              <SvgIcon className="linkedin-connection-process__image" icon={status.image} />
            </div>
          )}
        </div>

        {status.percentage && (
          <div className="linkedin-connection-process__progress-bar">
            <LinkedinConnectionProgressBar status={status} />
            <div className="large-bold linkedin-connection-process__progress-bar-percentage">
              {status.percentage}%
            </div>
          </div>
        )}

        <div className="linkedin-connection-process__sub-text">
          <span className="small linkedin-connection-process__sub-text-status-text">
            {status.text}
          </span>
        </div>

        <div className="linkedin-connection-process__timer-and-input">
          {status.timer && (
            <CircularTimer
              loading={value}
              status={status}
              updateValue={updateValue}
              executionSeconds={executionSeconds}
              executionMinutes={executionMinutes}
              pinTimestamp={pinTimestamp}
              timeIsUp={timeIsUp}
              executionTime={EXECUTION_TIME}
            />
          )}
          {status.OTPInput && (
            <div className="linkedin-connection-process__OTPInput">
              <OTPInput />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

// LinkedinConnectionProcess.propTypes = {
//   initialGlobalStatusState: PropTypes.number.isRequired,
// }

export default LinkedinConnectionProcess
